angular.module('mtic.components.login')
.directive('signup', function (
  $log,
  $q,
  api,
  $sce,
  $timeout,
  TIMING_CONSTANTS,
  $location,
  EventManager,
  language
) {
  return {
    templateUrl: 'template.html',
    scope: {
      dueToExpiry: '=dueTo'
    },
    link: function (scope) {
      /**
      * TEMPORARY
      * SHOULD BE LOADED FROM DB
      */
      scope.allowedSchools = {
        selected: null,
        list: [
          { id: 110, name: "Cycle 3 Module 1" },
          { id: 178, name: "Cycle 3 Module 2" },
          { id: 155, name: "Grade 7&8" },
        ]
      }
      var eventManager = new EventManager('signup',scope)
      var validator = Validator.validator();
      var is = Validator.Assert;
      scope.goToSigin = function(){
        eventManager.broadcast('login:open','signin')
      }
      try {
        scope.language = language;
        scope.currentUserType = "STUDENT";
        scope.isSigningUp = false;
        scope.studentData = {
          teacher_id: null, // 235c8456
          class_id: null,
          first_name: null,
          last_name: null,
          user_name: null,
          password: null,
          password_confirm: null,
          user_type: 'person'
        }
        scope.teacherData = {
          access_code: null,
          first_name: null,
          last_name: null,
          user_name: null,
          email: null,
          password: null,
          password_confirm: null,
          selected_school: null,
          allowed_email: false,
          user_type: 'person'
        }
        scope.$watch('teacherData.email', function(value){
          if(value) {
            if(value.indexOf('@education.lu') > 0) {
              scope.teacherData.allowed_email = true;
            }
          }
        })
        scope.$watch('allowedSchools.selected', function(value){
          if(value){
            scope.teacherData.selected_school = String(value.id);
          }
        })
        scope.setUserType = function (type) {
          scope.currentUserType = type;
        }

        scope.signUpStudent = function () {
          scope.isSigningUp = true;
          scope.validateStudentFormData().then(function () {
            return api.signUpStudent(
              scope.studentData.teacher_id,
              scope.studentData.class_id,
              scope.studentData.user_name,
              scope.studentData.password,
              scope.studentData.first_name,
              scope.studentData.last_name,
              scope.studentData.user_type
            )
          }).then(function (data) {
            return api.login({
              uuid: scope.studentData.user_name,
              password: scope.studentData.password
            });
          }).then(function (response) {
            $location.url('/home');
          }).catch(function (err) {
            if(err) {
              eventManager.broadcast('signup:fail', err.message)
            }
            scope.isSigningUp = false;
          })
        }

        scope.signUpTeacher = function () {
          scope.isSigningUp = true;
          scope.valudateTeacherFormData().then(function () {
            if(scope.teacherData.allowed_email) {
              return api.signUpTeacherThroughGroup({
                group_id: scope.teacherData.selected_school,
                user_name: scope.teacherData.user_name,
                password: scope.teacherData.password,
                first_name: scope.teacherData.first_name,
                last_name: scope.teacherData.last_name,
                email: scope.teacherData.email,
                user_type: scope.teacherData.user_type
              })
            }     else  {
              return api.signUpTeacher(
                scope.teacherData.access_code,
                scope.teacherData.user_name,
                scope.teacherData.password,
                scope.teacherData.first_name,
                scope.teacherData.last_name,
                scope.teacherData.email,
                scope.teacherData.user_type
              )
            }
          }).then(function (data) {
            return api.login({
              uuid: scope.teacherData.user_name,
              password: scope.teacherData.password
            });
          }).then(function () {
            $location.url('/home');
          }).catch(function (err) {
            if (err) {
              eventManager.broadcast('signup:fail', err.message)
            }
            scope.isSigningUp = false;
          })
        }

        var isNumber = function (val) {
          return !isNaN(Number(val))
        }
        scope.alert = {
          type: 'danger'
        };
        scope.validateStudentFormData = function () {
          $log.log(scope.studentData.teacher_id)
          return $q(function (resolve, reject) {
            var validationResult = validator.validate(scope.studentData, {
              teacher_id: [is.notBlank(), is.callback(isNumber)],
              class_id: [is.notBlank(), is.callback(isNumber)],
              first_name: [is.notBlank()],
              last_name: [is.notBlank()],
              user_name: [is.notBlank()],
              password: [is.notBlank()],
              password_confirm: [is.equalTo(scope.studentData.password)],
              user_type: [is.notBlank()]
            });
            if (validationResult === true) {
              resolve();
            } else {
              var errorMessages = [];
              if (validationResult.teacher_id) {
                errorMessages.push("- " + language.get('11325'))
              }
              if (validationResult.class_id) {
                errorMessages.push("- " + language.get('11326'))
              }
              if (validationResult.password_confirm) {
                errorMessages.push("- " + language.get('11327'))
              }
              errorMessages.push("- " + language.get('11328'))
              scope.alert.text = null;
              $timeout(function(){
                scope.alert.text = errorMessages[0]
              }, TIMING_CONSTANTS.INSTANT)
              // alertBoxRegistry.get("alert-message").error(errorMessages.join("<br>"));
              scope.isSigningUp = false;
              eventManager.broadcast('signup:validation:fail', {
                validationResult:validationResult,
                errorMessages:errorMessages
              })
              reject();
            }
          })
        }

        var parseDigits = function(val){
          var num = parseInt(val, 10);
          if (isNaN(num) || !num){
            num = 0;
          }
          return ''+num;
        }

        scope.splitCode = function(studentData){
          if (studentData && studentData.class_code_joined){
            var classCodeSplit = studentData.class_code_joined.split('c');
            studentData.teacher_id = parseDigits(classCodeSplit[0]);
            studentData.class_id = parseDigits(classCodeSplit[1]);
          }
        }

        scope.splitFullName = function(studentData){
          if (studentData && studentData.full_name_joined){
            var nameSplit = studentData.full_name_joined.split(' ');
            if (nameSplit.length === 1){
              studentData.first_name = studentData.full_name_joined
              studentData.last_name = '_'
            }
            else{
              studentData.last_name = nameSplit.pop();
              studentData.first_name = nameSplit.join(' ');
            }
          }
        }

        scope.valudateTeacherFormData = function () {
          return $q(function (resolve, reject) {
            var validations = {
              first_name: [is.notBlank()],
              last_name: [is.notBlank()],
              user_name: [is.notBlank()],
              email: [is.email(), is.notBlank()],
              password: [is.notBlank()],
              password_confirm: [is.equalTo(scope.teacherData.password)],
              user_type: [is.notBlank()]
            }
            if(!scope.teacherData.allowed_email){
              validations.access_code = [is.notBlank()]
            }else{
              validations.selected_school = [is.notBlank()]
            }
            var validationResult = validator.validate(scope.teacherData, validations);
            if (validationResult === true) {
              resolve();
            } else {
              var errorMessages = [];
              errorMessages.push("- " + language.get('11328'))
              if (validationResult.password_confirm) {
                errorMessages.push("- " + language.get('11327'))
              }
              if (validationResult.email) {
                errorMessages.push("- " + language.get('11330'))
              }
              if (validationResult.selected_school) {
                errorMessages.push("- " + 'Missing a school selection')
              }

              scope.alert.text = null;
              $timeout(function(){
                scope.alert.text = errorMessages[0]
              }, TIMING_CONSTANTS.INSTANT)

              // alertBoxRegistry.get("alert-message").error(errorMessages.join("<br>"), true);
              reject();
            }
          })
        }

      } catch (err) {
        $log.error(err);
      }
    }
  }
})
